import React, {Component} from "react"

import authentication from "@irati/auth"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import addOrRemoveFromArray from "@irati/utils/addOrRemoveFromArray"
import {ProductSettingsWellnessCategory, WellnessMediaCategory} from "@irati/types"
import productSettingsService from "@irati/permissions/services/productSettings"
import wellnessService from "@irati/wellness/services/Wellness"
import ListWrapper from "../PerksSettings/PerkVisibility/styled/ListWrapper"
import CategoryListItem from "./CategoryListItem/CategoryListItem"

interface Category {
  id: string
  name: string
}

interface State {
  categories: Category[]
  blacklistedCategories: Category[]
  load?: Promise<void>
}

export default class CategoryList extends Component<{}, State> {
  state: State = {
    categories: [],
    blacklistedCategories: [],
    load: hangPromise()
  }

  private mapWellnessMediaCategoryToCategory = (wellnessCategory: WellnessMediaCategory): Category => {
    return {
      id: wellnessCategory.uuid || wellnessCategory.id,
      name: wellnessCategory.name
    }
  }

  private mapWellnessCategoryToCategory = (wellnessCategory: ProductSettingsWellnessCategory): Category => {
    return {
      id: wellnessCategory.id,
      name: wellnessCategory.name
    }
  }

  componentDidMount() {
    const business = authentication.business()
    const load = productSettingsService.get(business.uuid, business.rootTeamId).then(async (ps) => {
      const blacklistedCategories = (ps.wellnessSettings?.blacklistedCategories || []).map(this.mapWellnessCategoryToCategory)
      this.setState({blacklistedCategories})

      const wellnessCategories = await wellnessService.getWellnessMediaCategories()
      const categories = wellnessCategories.map(this.mapWellnessMediaCategoryToCategory)
      this.setState({categories})
    })
    this.setState({load})
  }

  handleToggle = (category: Category) => {
    const newBlacklistedCategories = addOrRemoveFromArray(this.state.blacklistedCategories, category, (a, b) => a.id === b.id)

    const business = authentication.business()
    return productSettingsService
      .updateWellnessSettings(business.uuid, business.rootTeamId, {
        blacklistedCategories: newBlacklistedCategories.map((cat) => ({
          id: cat.id,
          name: cat.name
        }))
      })
      .then((ps) => {
        const blacklistedCategories = (ps.wellnessSettings?.blacklistedCategories || []).map(this.mapWellnessCategoryToCategory)
        this.setState({blacklistedCategories})
      })
  }

  isCategoryBlacklisted = (id: string) => {
    return this.state.blacklistedCategories.find((blacklistedCategory: Category) => blacklistedCategory.id === id)
  }

  render() {
    const {categories, load} = this.state

    return (
      <ListWrapper>
        <Loading load={load}>
          {categories.map((category) => (
            <CategoryListItem
              key={category.id}
              category={category}
              blacklisted={!!this.isCategoryBlacklisted(category.id)}
              handleToggle={this.handleToggle}
            />
          ))}
        </Loading>
      </ListWrapper>
    )
  }
}
